import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getApi } from 'redux/apis';

export const getCostAllocationAction = createAsyncThunk(
	'costAllocation/get',
	async (params: any, { rejectWithValue }) => {
		try {
			const { signal, ...restParams } = params;
			const response = await getApi(
				'/cost-allocation',
				{
					...restParams,
					companyId: localStorage.getItem('companyId'),
				},
				signal
			);
			return response.data.data;
		} catch (error: any) {
			if (axios.isCancel(error) || error?.name === 'CanceledError') {
				// Optionally return or ignore
				return;
			}
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getPaginationCostAllocationAction = createAsyncThunk(
	'paginate-costAllocation/get',
	async (params: any, { rejectWithValue }) => {
		try {
			const { signal, ...restParams } = params;
			const response = await getApi(
				'/cost-allocation',
				{
					...restParams,
					companyId: localStorage.getItem('companyId'),
				},
				signal
			);
			return response.data.data;
		} catch (error: any) {
			if (axios.isCancel(error) || error?.name === 'CanceledError') {
				// Optionally return or ignore
				return;
			}
			return rejectWithValue(error?.response?.data);
		}
	}
);
